import Checkbox from 'client/CommonComponents/Checkbox';
import AssetInventoryReadiness from './AssetInventoryReadiness';
import { useCallback, useEffect, useRef, useState } from 'react';
import { getRegion, setRegion } from 'Store/Organization/Region/RegionAction';
import { useDispatch, useSelector } from 'react-redux';
import { getMarketByRegion, setMarketByRegion } from 'Store/Organization/MarketByRegion/MarketByRegionAction';
import { getAssetReadinessWorkBookGrid, getAuditDateList, getAuditReadinessDateList, getAuditTrainingDateList, getCurrentAuditCycle, getSaveAssetReadinessWorkBook, setAssetReadinessWorkBookFilter, setAssetReadinessWorkBookGrid, setIsWorkBookGridBindOnload, setSaveAssetReadinessWorkBook } from 'Store/AssetManagement/AuditReadinessworkBook/AuditReadinessworkBookAction';
import { ReactSelectBox, Tooltip } from 'client/CommonComponents';
import { getCostCenterByMarket, setCostCenterByMarket } from 'Store/Organization/CostCenterByMarket/CostCenterByMarketAction';
import RejectedBee from '../../../assets/images/Confirmation Bee.svg';
import { popupInitialData } from 'utils';
import permissions, { isAuthorized } from 'client/utils/Permissions';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';

const AssetInventoryReadinessContainer = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const gridDataRef: any = useRef<any>([]);
    const searchedCostCenter: any = useRef<any>([])

    const [regionDropDownTemp, setRegionDropDownTemp] = useState([]);
    const [selectedRegion, setSelectedRegion] = useState<any>();
    const [marketDropDownTemp, setMarketDropDownTemp] = useState([]);
    const [selectedMarket, setSelectedMarket] = useState<any>();
    const [selectedSearchedCostCenter, setSelectedSearchedCostCenter] = useState<any>([]);
    const [costCenterDropDownTemp, setCostCenterDropDownTemp] = useState([]);
    const [gridData, setGridData] = useState<any>([]);

    const [paginationData, setPaginationData] = useState<any>({})
    const [pagesCount, setPagesCount] = useState<number>(0)
    const [serverTotal, setServerTotal] = useState(0)
    const [sortData, setSortData] = useState<any>('')
    const [showGrid, setShowGrid] = useState<boolean>(false)
    const [changedRowId, setChangedRowId] = useState<any>();
    const [isRegionSelected, setIsRegionSelected] = useState<any>(false)
    const [popupContent, setPopupContent] = useState<any>(popupInitialData);

    const [auditDateDropDownTemp, setAuditDateDropDownTemp] = useState([]);
    const [auditReadinessDateDropDownTemp, setAuditReadinessDateDropDownTemp] = useState([]);
    const [auditTrainingDateDropDownTemp, setAuditTrainingDateDropDownTemp] = useState([]);
    const [auditCycleRange,setAuditCycleRange] = useState<any>('');

    const {
        regionDropDownList,
        marketByRegionDropDownList,
        readinessWorkBookGrid,
        costCenterByMarketList,
        getUserDetails,
        isSaveAssetReadinessWorkBook,
        isDropDownsLoading,
        auditDateList,
        auditReadinessDateList,
        auditTrainingDateList,
        isWorkBookGridBindOnload,
        assetReadinessWorkBookFilter,
        auditCycle
    } = useSelector((state: any) => ({
        regionDropDownList: state.RegionDropDownReducer.regionDropDownList,
        marketByRegionDropDownList: state.MarketByRegionReducers.marketByRegionDropDownList,
        readinessWorkBookGrid: state.AuditReadinessWorkBookReducers.readinessWorkBookGrid,
        costCenterByMarketList: state.CostCenterByMarketReducers.costCenterByMarket,
        getUserDetails: state.UserProfile.getUserDetails,
        isSaveAssetReadinessWorkBook: state.AuditReadinessWorkBookReducers.isSaveAssetReadinessWorkBook,
        isDropDownsLoading: state.AuditReadinessWorkBookReducers.isDropDownsLoading,
        auditDateList: state.AuditReadinessWorkBookReducers.auditDateDropDown,
        auditReadinessDateList: state.AuditReadinessWorkBookReducers.auditReadinessDateDropDown,
        auditTrainingDateList: state.AuditReadinessWorkBookReducers.auditTrainingDateDropDown,
        isWorkBookGridBindOnload: state.AuditReadinessWorkBookReducers.isWorkBookGridBindOnload,
        assetReadinessWorkBookFilter: state.AuditReadinessWorkBookReducers.assetReadinessWorkBookFilter,
        auditCycle : state.AuditReadinessWorkBookReducers.auditCycle
    }));

    useEffect(() => {
        if (!isAuthorized(permissions.View_AssetAuditReadinessWB) && getUserDetails?.permissions) {
            navigate('/assetinventory')
        }
        dispatch(getRegion());
        setIsRegionSelected(false)
        if (assetReadinessWorkBookFilter == null || assetReadinessWorkBookFilter == undefined || (assetReadinessWorkBookFilter?.hasOwnProperty('costCenter') && (assetReadinessWorkBookFilter?.costCenter?.length == 0 || assetReadinessWorkBookFilter?.costCenter == null || assetReadinessWorkBookFilter?.costCenter == undefined))) {
            gridDataRef.current = []
            setRegionDropDownTemp([])
            setSelectedRegion('')
            setMarketDropDownTemp([])
            setSelectedMarket('')
            setSelectedSearchedCostCenter('')
            setCostCenterDropDownTemp([])
            setGridData([])
            dispatch(setCostCenterByMarket([]))
            dispatch(setMarketByRegion([]))
            dispatch(setRegion([]))
            dispatch(setAssetReadinessWorkBookGrid([]))
            setShowGrid(false)
            dispatch(setSaveAssetReadinessWorkBook(null))
            searchedCostCenter.current = []
        }
    }, [])

    useEffect(() => {
        if (assetReadinessWorkBookFilter?.hasOwnProperty('costCenter') && assetReadinessWorkBookFilter?.costCenter?.length) {
            setSelectedSearchedCostCenter(assetReadinessWorkBookFilter?.costCenter)
            setSelectedMarket(assetReadinessWorkBookFilter?.market)
            setSelectedRegion(assetReadinessWorkBookFilter?.region)
            dispatch(getMarketByRegion(assetReadinessWorkBookFilter?.region?.value))
            dispatch(getCostCenterByMarket({ marketId: assetReadinessWorkBookFilter?.market?.value }))
            let costCenterValue: any = []
            assetReadinessWorkBookFilter?.costCenter?.map((item: any) => {
                costCenterValue.push(parseInt(item?.value))
            })
            searchedCostCenter.current = costCenterValue
            fetchGridData(assetReadinessWorkBookFilter?.region, assetReadinessWorkBookFilter?.market, costCenterValue)
        }
    }, [assetReadinessWorkBookFilter])

    useEffect(() => {
        if (getUserDetails?.hasOwnProperty('userGridFilters') && regionDropDownTemp?.length > 0 && !isWorkBookGridBindOnload) {
            let region: any = {}
            let market: any = {}
            let costCenter: any = []
            let costCenterTemp: any = []
            getUserDetails?.userGridFilters?.map((item: any) => {
                if (item?.pageName == "Asset Inventory") {
                    item?.gridFilter?.map((itemVal?: any) => {
                        itemVal?.filterValues?.map((val?: any) => {
                            if (val?.filterName == "region" && regionDropDownTemp?.length > 0 && val?.filterValue) {
                                let regionTemp: any = regionDropDownTemp?.find((item?: any) => item?.value == val?.filterValue)
                                if (regionTemp) {
                                    region = regionTemp
                                    setSelectedRegion(regionTemp)
                                    if (marketDropDownTemp?.length <= 0) {
                                        dispatch(getMarketByRegion(regionTemp?.value))
                                    }
                                }
                            } if (val?.filterName == "market" && marketDropDownTemp?.length > 0 && val?.filterValue) {
                                let marketTemp: any = marketDropDownTemp?.find((item?: any) => item?.value == val?.filterValue)
                                if (marketTemp) {
                                    market = marketTemp
                                    setSelectedMarket(marketTemp)
                                    if (costCenterDropDownTemp?.length <= 0) {
                                        dispatch(getCostCenterByMarket({ marketId: marketTemp?.value }))
                                    }
                                }
                            } if (val?.filterName == "costCenters" && costCenterDropDownTemp?.length > 0 && val?.filterValue) {
                                val?.filterValue?.split(',').map((costCenterItem?: any) => {
                                    let val : any = costCenterDropDownTemp?.find((item?: any) => item?.value == costCenterItem)
                                    if(val){
                                        costCenterTemp.push(val)
                                    }
                                })
                                if (costCenterTemp?.length > 0) {
                                    costCenter = val?.filterValue.split(',')
                                    searchedCostCenter.current = costCenter
                                    setSelectedSearchedCostCenter(costCenterTemp)
                                }
                            }
                        })
                    })
                    if (getUserDetails?.hasOwnProperty('userGridFilters') && costCenterDropDownTemp?.length > 0 && marketDropDownTemp?.length > 0 && regionDropDownTemp?.length > 0) {
                        fetchGridData(region, market, costCenter)
                        dispatch(setAssetReadinessWorkBookFilter({
                            region: region,
                            market: market,
                            costCenter: costCenterTemp
                        }))
                        dispatch(setIsWorkBookGridBindOnload(true))
                    }
                }
            })
        }
    }, [getUserDetails, regionDropDownTemp, marketDropDownTemp, costCenterDropDownTemp])

    const hideDialog = () => setPopupContent({ ...popupContent, isDialogVisible: false });

    useEffect(() => {
        if (isSaveAssetReadinessWorkBook != null && changedRowId && isSaveAssetReadinessWorkBook && isSaveAssetReadinessWorkBook != "error") {
            let gridDataTemp = gridDataRef.current ? JSON.parse(JSON.stringify(gridDataRef.current)) : []
            gridDataTemp?.map((item: any) => {
                if (item?.rowId == changedRowId) {
                    item.arWbId = isSaveAssetReadinessWorkBook;
                }
            }
            )
            gridDataRef.current = gridDataTemp
            setGridData(gridDataTemp)
            dispatch(setSaveAssetReadinessWorkBook(null))
        } else if (isSaveAssetReadinessWorkBook != null && changedRowId && isSaveAssetReadinessWorkBook == "error") {
            setPopupContent({
                ...popupContent,
                title: "INFORMATION",
                titleImg: RejectedBee,
                isDialogVisible: true,
                isTitleWarning: false,
                subtextcontent: "Error occured while saving the data. Please try again.",
                outlineBtnText: "Ok",
                isSingleConfirmationBtn: true,
                isCommentboxVisible: false,
                isCommentBoxRequire: false,
                isCompletedReportVisible: false,
                popupOutlinebtnOnclick: () => {
                    hideDialog();
                    gridDataRef.current = gridData
                    dispatch(setSaveAssetReadinessWorkBook(null))
                }
            });

        }
    }, [isSaveAssetReadinessWorkBook])

    useEffect(() => {
        if (readinessWorkBookGrid?.data?.length > 0) {
            setServerTotal(readinessWorkBookGrid?.totalRecords)
            let val = readinessWorkBookGrid?.data?.map((item?: any, index?: any) => {
                return {
                    ...item,
                    rowId: index + 1
                }
            })
            setGridData(val)
            gridDataRef.current = val
            setShowGrid(true)
        } else {
            setShowGrid(false)
        }
    }, [readinessWorkBookGrid])

    useEffect(() => {
        dispatch(getCurrentAuditCycle())
        !(auditDateList?.length > 0) && dispatch(getAuditDateList())
        !(auditReadinessDateList?.length > 0) && dispatch(getAuditReadinessDateList())
        !(auditTrainingDateList?.length > 0) && dispatch(getAuditTrainingDateList())
    }, [])

    useEffect(()=>{
        if(auditCycle?.cycleStartDate && auditCycle?.cycleEndDate){
            const formattedStartDate = moment(auditCycle?.cycleStartDate)?.format("MM/DD/YYYY");
            const formattedEndDate = moment(auditCycle?.cycleEndDate)?.format("MM/DD/YYYY");
            setAuditCycleRange(`${formattedStartDate} - ${formattedEndDate}`);
        }
    },[auditCycle])

    useEffect(() => {
        if (regionDropDownList?.length > 0) {
            let val = regionDropDownList?.map((item?: any) =>
                ({ value: item?.value, label: item?.text, key: item?.value })
            )
            setRegionDropDownTemp(val)
        }
    }, [regionDropDownList])

    useEffect(() => {
        if (auditDateList?.length > 0) {
            let val = auditDateList?.map((item?: any) =>
                ({ value: item?.value, label: item?.text, key: item?.value })
            )
            setAuditDateDropDownTemp(val);
        }
    }, [auditDateList])

    useEffect(() => {
        if (auditReadinessDateList?.length > 0) {
            let val = auditReadinessDateList?.map((item?: any) =>
                ({ value: item?.value, label: item?.text, key: item?.value })
            )
            setAuditReadinessDateDropDownTemp(val);
        }
    }, [auditReadinessDateList])

    useEffect(() => {
        if (auditTrainingDateList?.length > 0) {
            let val = auditTrainingDateList?.map((item?: any) =>
                ({ value: item?.value, label: item?.text, key: item?.value })
            )
            setAuditTrainingDateDropDownTemp(val);
        }
    }, [auditTrainingDateList])

    useEffect(() => {
        if (costCenterByMarketList?.length > 0) {
            let val = costCenterByMarketList?.map((item?: any) =>
                ({ value: item?.value, label: item?.text, key: item?.value })
            )
            setCostCenterDropDownTemp(val)
        }
    }, [costCenterByMarketList])

    useEffect(() => {
        if (marketByRegionDropDownList?.length > 0) {
            let val = marketByRegionDropDownList?.map((item?: any) =>
                ({ value: item?.value, label: item?.text, key: item?.value })
            )
            setMarketDropDownTemp(val)
            if (marketByRegionDropDownList?.length == 1 && selectedRegion && isRegionSelected) {
                setSelectedMarket(val[0])
                fetchGridData(selectedRegion, val[0])
                setIsRegionSelected(false)
                dispatch(getCostCenterByMarket({ marketId: val[0]?.value }))
                dispatch(setAssetReadinessWorkBookFilter({
                    region: selectedRegion,
                    market: val[0],
                    costCenter: null
                }))
            }
        }
    }, [marketByRegionDropDownList])

    const onIsCheckBoxChange = (e?: any, rowData?: any, key?: any, isSelectBox: boolean = false) => {
        let ChangedRowData: any = {}
        let gridDataTemp = gridDataRef.current ? JSON.parse(JSON.stringify(gridDataRef.current)) : []
        gridDataTemp?.map((item: any) => {
            if (item?.rowId == rowData?.rowId) {
                if (isSelectBox) {
                    ChangedRowData = {
                        property: getPropertyName(key),
                        value: e?.label
                    }
                    item[key] = e?.label
                }
                else {
                    ChangedRowData = {
                        property: getPropertyName(key),
                        value: !item[key]
                    }
                    item[key] = !item[key]
                }
            }
        }
        )
        if (ChangedRowData.hasOwnProperty("property")) {
            let payload: any = {
                arWbId: rowData?.arWbId,
                cycleId: rowData?.cycleId,
                costCenterId: rowData?.costCenterId,
                savedBy: getUserDetails?.emailId,
                propertyName: ChangedRowData?.property,
                propertyValue: ChangedRowData?.value?.toString()
            }
            dispatch(getSaveAssetReadinessWorkBook(payload))
            setChangedRowId(rowData?.rowId)
        }
        gridDataRef.current = gridDataTemp
    }

    const getPropertyName = (property: any) => {
        return property.substring(2);
    }

    const barcodeReplacementOrderOptions = [
        { label: "Not Started", key: 1, value: 1 },
        { label: "In Progress", key: 2, value: 2 },
        { label: "Completed", key: 3, value: 3 }]

    const columns = [
        {
            key: "costCenterName",
            title: "Cost Center",
            width: 140,
        },
        {
            key: "arBmcommunicationToTeam",
            title: "BM Communication to Team",
            width: 140,
            isSortable: false,
            Cell: (row: any) => {
                return (
                    <Checkbox
                        className="mb-0 checkboxName"
                        onChange={(e?: any) => onIsCheckBoxChange(e, row?.rowData, row?.column?.key)}
                        checked={row?.rowData?.arBmcommunicationToTeam}
                        disabled={!isAuthorized(permissions.SaveEdit_AssetAuditReadinessWB)}  data-attribute="AssetInventoryReadiness_container_Default_Checkbox" />
                );
            },
        },
        {
            key: "arBranchAssetRegisterCorrectionsBm",
            title: "Branch Asset Register Corrections by BM",
            width: 120,
            isSortable: false,
            Cell: (row: any) => {
                return (
                    <Checkbox
                        className="mb-0 checkboxName"
                        onChange={(e?: any) => onIsCheckBoxChange(e, row?.rowData, row?.column?.key)}
                        checked={row?.rowData?.arBranchAssetRegisterCorrectionsBm}
                        disabled={!isAuthorized(permissions.SaveEdit_AssetAuditReadinessWB)}  data-attribute="AssetInventoryReadiness_container_Default_Checkbox_2" />
                );
            },
        },
        {
            key: "arBranchStarterKitOrderedOptional",
            title: "REM Branch Starter Kit Ordered (Optional)",
            width: 120,
            isSortable: false,
            Cell: (row: any) => {
                return (
                    <Checkbox
                        className="mb-0 checkboxName"
                        onChange={(e?: any) => onIsCheckBoxChange(e, row?.rowData, row?.column?.key)}
                        checked={row?.rowData?.arBranchStarterKitOrderedOptional}
                        disabled={!isAuthorized(permissions.SaveEdit_AssetAuditReadinessWB)}  data-attribute="AssetInventoryReadiness_container_Default_Checkbox_3" />
                );
            },
        },
        {
            key: "arBarcodeReplacementOrdered",
            title: "Barcode Replacement Ordered",
            isSortable: false,
            width: 150,
            Cell: (row: any) => {
                return (
                    <span className='tooltip-description'>
                        <Tooltip content={row?.rowData?.arBarcodeReplacementOrdered ?? ''} data-attribute="AssetInventoryReadiness_container_Default_Tooltip">
                            <ReactSelectBox
                                className="mb-0 checkboxName"
                                onChange={(e?: any) => onIsCheckBoxChange(e, row?.rowData, row?.column?.key, true)}
                                value={row?.rowData?.arBarcodeReplacementOrdered ? { label: row?.rowData?.arBarcodeReplacementOrdered, key: row?.rowData?.arBarcodeReplacementOrdered, value: row?.rowData?.arBarcodeReplacementOrdered } : { label: "Completed", key: 3, value: 3 }}
                                options={barcodeReplacementOrderOptions}
                                isDisabled={!isAuthorized(permissions.SaveEdit_AssetAuditReadinessWB)}  data-attribute="AssetInventoryReadiness_container_Default_SearchSelectBox" />
                        </Tooltip>
                    </span>
                );
            },
        },
        {
            key: "arInventoryTeamAssignedLeadr",
            title: "Inventory Team Assigned in LEADR",
            width: 120,
            isSortable: false,
            Cell: (row: any) => {
                return (
                    <Checkbox
                        className="mb-0 checkboxName"
                        onChange={(e?: any) => onIsCheckBoxChange(e, row?.rowData, row?.column?.key)}
                        checked={row?.rowData?.arInventoryTeamAssignedLeadr}
                        disabled={!isAuthorized(permissions.SaveEdit_AssetAuditReadinessWB)}  data-attribute="AssetInventoryReadiness_container_Default_Checkbox_4" />
                );
            },
        },
        {
            key: "arReadinessGuideMarketTrainingDate",
            title: "Readiness Guide Market Training Date",
            width: 200,
            isSortable: false,
            Cell: (row: any) => {
                return (
                    <span className='tooltip-description'>
                        <Tooltip content={row?.rowData?.arReadinessGuideMarketTrainingDate ?? ''} data-attribute="AssetInventoryReadiness_container_Default_Tooltip_2">
                            <ReactSelectBox
                                className="mb-0 checkboxName"
                                onChange={(e?: any) => onIsCheckBoxChange(e, row?.rowData, row?.column?.key, true)}
                                value={row?.rowData?.arReadinessGuideMarketTrainingDate ? { label: row?.rowData?.arReadinessGuideMarketTrainingDate, key: row?.rowData?.arReadinessGuideMarketTrainingDate, value: row?.rowData?.arReadinessGuideMarketTrainingDate } : { label: "Select Date", key: 1, value: 1 }}
                                options={auditReadinessDateDropDownTemp}
                                isDisabled={!isAuthorized(permissions.SaveEdit_AssetAuditReadinessWB)}  data-attribute="AssetInventoryReadiness_container_Default_SearchSelectBox_2" />
                        </Tooltip>
                    </span>
                );
            },
        },
        {
            key: "arBranchPlanCompleted",
            title: "Branch Plan Completed",
            width: 140,
            isSortable: false,
            Cell: (row: any) => {
                return (
                    <Checkbox
                        className="mb-0 checkboxName"
                        onChange={(e?: any) => onIsCheckBoxChange(e, row?.rowData, row?.column?.key)}
                        checked={row?.rowData?.arBranchPlanCompleted}
                        disabled={!isAuthorized(permissions.SaveEdit_AssetAuditReadinessWB)}  data-attribute="AssetInventoryReadiness_container_Default_Checkbox_5" />
                );
            },
        },
        {
            key: "arScanningAppDownloadTrainingActivityDate",
            title: "Scanning App Download & Training Activity Date",
            width: 200,
            isSortable: false,
            Cell: (row: any) => {
                return (
                    <span className='tooltip-description'>
                        <Tooltip content={row?.rowData?.arScanningAppDownloadTrainingActivityDate ?? ''} data-attribute="AssetInventoryReadiness_container_Default_Tooltip_3">
                            <ReactSelectBox
                                className="mb-0 checkboxName"
                                onChange={(e?: any) => onIsCheckBoxChange(e, row?.rowData, row?.column?.key, true)}
                                value={row?.rowData?.arScanningAppDownloadTrainingActivityDate ? { label: row?.rowData?.arScanningAppDownloadTrainingActivityDate, key: row?.rowData?.arScanningAppDownloadTrainingActivityDate, value: row?.rowData?.arScanningAppDownloadTrainingActivityDate } : { label: "Select Date", key: 1, value: 1 }}
                                options={auditTrainingDateDropDownTemp}
                                isDisabled={!isAuthorized(permissions.SaveEdit_AssetAuditReadinessWB)}  data-attribute="AssetInventoryReadiness_container_Default_SearchSelectBox_3" />
                        </Tooltip>
                    </span>
                );
            },
        },
        {
            key: "arScheduledInventoryDate",
            title: "Scheduled Inventory Date",
            width: 200,
            isSortable: false,
            Cell: (row: any) => {
                return (
                    <span className='tooltip-description'>
                        <Tooltip content={row?.rowData?.arScheduledInventoryDate ?? ''} data-attribute="AssetInventoryReadiness_container_Default_Tooltip_4">
                            <ReactSelectBox
                                className="mb-0 checkboxName"
                                onChange={(e?: any) => onIsCheckBoxChange(e, row?.rowData, row?.column?.key, true)}
                                value={row?.rowData?.arScheduledInventoryDate ? { label: row?.rowData?.arScheduledInventoryDate, key: row?.rowData?.arScheduledInventoryDate, value: row?.rowData?.arScheduledInventoryDate } : { label: "Select Date", key: 1, value: 1 }}
                                options={auditDateDropDownTemp}
                                isDisabled={!isAuthorized(permissions.SaveEdit_AssetAuditReadinessWB)}  data-attribute="AssetInventoryReadiness_container_Default_SearchSelectBox_4" />
                        </Tooltip>
                    </span>
                );
            },
        },
        {
            key: "arScheduledInventoryPlanBdate",
            title: "Scheduled Inventory Plan B Date",
            width: 200,
            isSortable: false,
            Cell: (row: any) => {
                return (
                    <span className='tooltip-description'>
                        <Tooltip content={row?.rowData?.arScheduledInventoryPlanBdate ?? ''} data-attribute="AssetInventoryReadiness_container_Default_Tooltip_5">
                            <ReactSelectBox
                                className="mb-0 checkboxName"
                                onChange={(e?: any) => onIsCheckBoxChange(e, row?.rowData, row?.column?.key, true)}
                                value={row?.rowData?.arScheduledInventoryPlanBdate ? { label: row?.rowData?.arScheduledInventoryPlanBdate, key: row?.rowData?.arScheduledInventoryPlanBdate, value: row?.rowData?.arScheduledInventoryPlanBdate } : { label: "Select Date", key: 1, value: 1 }}
                                options={auditDateDropDownTemp}
                                isDisabled={!isAuthorized(permissions.SaveEdit_AssetAuditReadinessWB)}  data-attribute="AssetInventoryReadiness_container_Default_SearchSelectBox_5" />
                        </Tooltip>
                    </span>
                );
            },
        },
    ];

    const handleChangeRegion = (value: any) => {
        setIsRegionSelected(true)
        setSelectedRegion(value);
        setSelectedMarket('')
        setMarketDropDownTemp([])
        setCostCenterDropDownTemp([])
        setSelectedSearchedCostCenter('')
        dispatch(getMarketByRegion(value?.value));
        dispatch(setAssetReadinessWorkBookGrid([]))
        setGridData([])
        searchedCostCenter.current = []
    }

    const handleChangeMarket = (value: any, key: any) => {
        setSelectedMarket(value)
        fetchGridData(selectedRegion, value)
        setCostCenterDropDownTemp([])
        setSelectedSearchedCostCenter('')
        searchedCostCenter.current = []
        dispatch(setAssetReadinessWorkBookFilter({
            region: selectedRegion,
            market: value,
            costCenter: null
        }))
        dispatch(getCostCenterByMarket({ marketId: value?.value }))
    }

    useEffect(() => {
        if (serverTotal && paginationData?.pageSize) {
            let pageSize = paginationData?.pageSize
            let tempPageCount = serverTotal > pageSize ? Math.ceil(serverTotal / pageSize - 1) : 0
            setPagesCount(tempPageCount)
        }
    }, [serverTotal, paginationData?.pageSize])

    const fetchAction = useCallback((fetchData: any) => {
        if (selectedMarket?.value) {
            if (fetchData.action && fetchData.action === "paging") {
                setPaginationData(fetchData.data)
                fetchGridData(selectedRegion, selectedMarket, searchedCostCenter.current, fetchData.data, sortData)
            }
            if (fetchData.action && fetchData.action === "sorting") {
                setSortData(fetchData.data[0]);
                fetchGridData(selectedRegion, selectedMarket, searchedCostCenter.current, paginationData, fetchData.data[0])
            }
        }
    }, [selectedRegion, selectedMarket])

    const getPaginationData = (costCenterValue?: any, pageData?: any) => {
        if (pageData?.pageIndex != undefined && costCenterValue?.length && costCenterValue != null && costCenterValue != undefined) {
            return 1
        } else if (pageData?.pageIndex != undefined) {
            return pageData?.pageIndex + 1
        } else {
            return 1
        }
    }

    const fetchGridData = (region?: any, market?: any, costCenterValue?: any, pageData?: any, sortingData?: any) => {
        if (region?.value) {
            let payload: any = {
                pageNumber: getPaginationData(costCenterValue, pageData),
                pageSize: pageData?.pageSize,
                marketId: parseInt(market?.value),
                regionCode: region?.value?.toString(),
                costCenterIds: costCenterValue?.length ? costCenterValue : null,
                loggedInMail: getUserDetails?.emailId
            }
            if (sortingData?.key != '') {
                payload.sortBy = sortingData?.key;
                payload.sortOrder = sortingData?.sortDirection;
            }
            dispatch(getAssetReadinessWorkBookGrid(payload))
        }
    }

    const handleCostCenterOnChange = (value?: any) => {
        setSelectedSearchedCostCenter(value)
    }

    const handleSearchClick = (e: any) => {
        e.preventDefault();
        if (selectedSearchedCostCenter?.length) {
            let costCenterValue: any = []
            selectedSearchedCostCenter?.map((item: any) => {
                costCenterValue.push(parseInt(item?.value))
            })
            searchedCostCenter.current = costCenterValue
            dispatch(setAssetReadinessWorkBookFilter({
                region: selectedRegion,
                market: selectedMarket,
                costCenter: selectedSearchedCostCenter
            }))
            setShowGrid(false)
        }
    }

    const handleClearClick = () => {
        setSelectedSearchedCostCenter([])
        searchedCostCenter.current = []
        dispatch(setAssetReadinessWorkBookFilter(
            {
                region: selectedRegion,
                market: selectedMarket,
                costCenter: null
            }
        ))
        fetchGridData(selectedRegion, selectedMarket, null)
    }

    return (
        <AssetInventoryReadiness
            columns={columns}
            regionDropDownTemp={regionDropDownTemp}
            handleChangeRegion={handleChangeRegion}
            marketDropDownTemp={marketDropDownTemp}
            selectedRegion={selectedRegion}
            selectedMarket={selectedMarket}
            handleChangeMarket={handleChangeMarket}
            fetchAction={fetchAction}
            showGrid={showGrid}
            pagesCount={pagesCount}
            gridData={gridDataRef.current}
            serverTotal={serverTotal}
            costCenterDropDownTemp={costCenterDropDownTemp}
            handleCostCenterOnChange={handleCostCenterOnChange}
            selectedSearchedCostCenter={selectedSearchedCostCenter}
            handleSearchClick={handleSearchClick}
            hideDialog={hideDialog}
            popupContent={popupContent}
            handleClearClick={handleClearClick}
            isLoading={isDropDownsLoading}
            auditCycleRange = {auditCycleRange}
        />
    );
}

export default AssetInventoryReadinessContainer;